import { render, staticRenderFns } from "./ProductCodeEdit.vue?vue&type=template&id=e5806e2e&scoped=true"
import script from "./ProductCodeEdit.vue?vue&type=script&lang=js"
export * from "./ProductCodeEdit.vue?vue&type=script&lang=js"
import style0 from "./ProductCodeEdit.vue?vue&type=style&index=0&id=e5806e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5806e2e",
  null
  
)

export default component.exports